<template>
  <div class="page page-liuxuan-psychology"
       @click="handleShowQrCode"
  >
    <img class="banner"
         :src="require('@/assets/img/liuxuan-psychology/banner.png')"
         alt="banner"
    />

    <div class="content">
      <div class="info"
           :class="{ 'count-down-show': countDown.show }"
      >
        <div class="figure-block"
             :class="{ 'count-down-show': countDown.show }"
        >
          <img class="figure-img"
               :src="require('@/assets/img/liuxuan-psychology/figure.png')"
               alt=""
          />
        </div>
        <count-down :start="render.currentTime"
                    :end="countDown.endTime"
                    :block-bg-img="require('@/assets/img/liuxuan-psychology/count_down_block.png')"
                    :item-bg-img="require('@/assets/img/liuxuan-psychology/count_down_item.png')"
                    item-color="#44448f"
                    v-if="countDown.show"
        />
        <div class="video"
             :class="{ 'count-down-hide': !countDown.show }"
        >
          <img class="video-cover"
               :src="video.src"
               alt="视频封面"
          />
          <img class="video-icon"
               :src="require('@/assets/img/liuxuan-psychology/play.png')"
               alt="播放按钮"
          />
        </div>
        <div class="paragraph">
          孩子的身高、体重可以测量，但内心的成长确是看不见、摸不着。
          如何培育孩子的内心，牵引孩子往正确的方向前进，是全天下父母的共同课题。
        </div>
        <div class="paragraph">
          6-14岁，孩子从幼儿走向青少年，剧烈的身心变化连他自己也无所适从。
          父母又该如何从旁辅助，守护孩子坚强茁壮成长？
        </div>
        <div class="paragraph">
          知名作家刘墉之子，哈佛心理学者刘轩推出第一门给孩子的心理学，教孩子比IQ更重要的事。
          以幽默的口吻，带领孩子参与一场场有趣的心理学实验。
        </div>
      </div>

      <course-info :status="render.status"
      />

      <question-list :list="messages"
      />
    </div>

    <img class="footer"
         :src="require('@/assets/img/liuxuan-psychology/footer.png')"
         alt=""
    />

    <qr-code-popup :qr-code="qrCode.src"
                   :show.sync="showQrCode"
    />
  </div>
</template>

<script>
  import getLiuXuanPsychologyInfo from '@/services/liuxuan-psychology';
  import CourseInfo from '@/pages/2019/LiuXuanPsychology/components/CourseInfo';
  import QuestionList from '@/pages/2019/LiuXuanPsychology/components/QuestionList';
  import QrCodePopup from '@/pages/2019/LiuXuanPsychology/components/QrCodePopup';
  import CountDown from '@/components/CountDown';

  export default {
    name: 'LiuXuanPsychology',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      CourseInfo,
      QuestionList,
      QrCodePopup,
      CountDown,
    },
    data() {
      return {
        showQrCode: false,
        countDown: {
          endTime: 0,
          startTime: 0,
          show: false,
        },
        messages: [],
        qrCode: {
          src: '',
        },
        render: {
          pageTitle: '刘轩活动页',
          status: '',
          currentTime: 0,
        },
        video: {
          src: '',
        },
        currentView: '',
      };
    },
    computed: {
      currTime() {
        return new Date().getTime();
      },
    },
    methods: {
      async fetchData() {
        const data = await getLiuXuanPsychologyInfo();
        this.countDown = data.countDown;
        this.messages = data.messages;
        this.qrCode = data.qrCode;
        this.render = data.render;
        this.video = data.video;
      },
      handleShowQrCode() {
        this.showQrCode = true;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-liuxuan-psychology {
    background: linear-gradient(#f37f57, #ffd870);
  }

  img {
    margin: 0 auto;
    display: block;
  }

  .banner {
    max-width: 100%;
  }

  .content {
    img {
      max-width: 1100px;
    }
  }

  .info {
    margin: 0 auto;
    padding-top: 150px;
    box-sizing: border-box;
    width: 1234px;
    height: 1292px;
    background: url("~@/assets/img/liuxuan-psychology/info.png") no-repeat;
    background-size: contain;
    display: flex;
    flex-direction: column;
    align-items: center;
    &.count-down-show {
      padding-top: 100px;
    }
  }

  .figure-block {
    width: 854px;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    .figure-img {
      margin: 0;
      display: block;
      width: 280px;
      height: 160px;
    }
    &.count-down-show {
      margin-bottom: -60px;
      position: relative;
      padding-right: 12px;
      justify-content: flex-end;
    }
  }

  .video {
    width: 790px;
    height: 440px;
    margin-bottom: @size-medium;
    margin-top: -4px;
    border-radius: 0 0 45px 45px;
    position: relative;
    overflow: hidden;
    .video-cover {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 0 0 45px 45px;
    }
    .video-icon {
      width: 126px;
      height: 126px;
      display: block;
      position: absolute;
      top: 100px;
      left: 336px;
      z-index: 2;
    }
    &.count-down-hide {
      margin-bottom: 96px;
      border-radius: 45px;
      .video-cover {
        border-radius: 45px;
      }
    }
    &:after {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      content: '';
      display: block;
      background: fade(@color-black, 40%);
      z-index: 1;
    }
  }

  .paragraph {
    width: 920px;
    color: @color-text-base;
    font-size: @font-size-extra-small;
    line-height: 1.4;
    &:not(:last-child) {
      margin-bottom: 25px;
    }
  }

  .footer {
    display: block;
    max-width: 100%;
  }

</style>
